// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7JjtdagQCmoKZWr8xoEcsktVu-N9lqV8",
  authDomain: "satsoft-955e3.firebaseapp.com",
  databaseURL: "https://satsoft-955e3-default-rtdb.firebaseio.com",
  projectId: "satsoft-955e3",
  storageBucket: "satsoft-955e3.appspot.com",
  messagingSenderId: "54718658776",
  appId: "1:54718658776:web:f53519fc1cbb974f38ffad"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and export it
export const db = getFirestore(app);
